import google from 'images/logos/google-logo.svg';
import github from 'images/logos/github-logo.svg';
import slack from 'images/logos/slack-logo.svg';
import bitbucket from 'images/logos/bitbucket-logo.svg';
import gitlab from 'images/logos/gitlab-logo.svg';
import azureDevops from 'images/logos/azure-devops.svg';
import msTeams from 'images/logos/microsoft-teams-logo.svg';
import jira from 'images/logos/jira-logo.svg';
import azure_boards from 'images/logos/azure-boards.svg';
import axios from '../requester';
import { API } from '../constants/api-urls';
import QueryString from 'qs';
import _ from 'lodash';

export const TOKEN_VALIDATION_STATUS = {
  VALID: 'VALID',
  INVALID: 'INVALID',
  ERROR: 'ERROR',
  MISSING_SCOPES: 'MISSING_SCOPES',
  EXPIRED: 'EXPIRED',
  NOT_RELATED_TO_ORG: 'NOT_RELATED_TO_ORG'
};

export const SENSOR_AUTH_TYPES = {
  TOKEN: 'token',
  OAUTH2: 'oauth2'
};

export const isSensorOAuth2 = sensor =>
  sensor?.profile?.auth_type === SENSOR_AUTH_TYPES.OAUTH2;

export const getSensorAuthorizations = async ({
  withProfile = false,
  withGitStreamEnabled = false,
  add_pr_stats = false
} = {}) =>
  axios.get(API.SENSOR_AUTHORIZATIONS_PATH, {
    params: {
      with_profile: withProfile,
      ...(withGitStreamEnabled && {
        with_gitstream_enabled: withGitStreamEnabled
      }),
      ...(add_pr_stats && { add_pr_stats })
    }
  });

export const createSensorAuthorization = async (body, qs) =>
  axios.post(
    `${API.SENSOR_AUTHORIZATIONS_PATH}${
      _.isEmpty(qs) ? '' : `?${QueryString.stringify(qs)}`
    }`,
    body
  );
export const deleteSensorAuthorization = async (id, params) =>
  axios.delete(`${API.SENSOR_AUTHORIZATIONS_PATH}/${id}`, { params });
export const updateSensorAuthorization = async (id, data) =>
  axios.patch(`${API.SENSOR_AUTHORIZATIONS_PATH}/${id}`, data);

export const providerLogos = {
  google,
  github,
  slack,
  bitbucket,
  bitbucket_server: bitbucket,
  gitlab,
  azure_devops: azureDevops,
  azure_ad_oauth2: msTeams,
  JIRA: jira,
  azure_boards
};

export const getSensorScopesValidation = async sensorId => {
  return axios.get(`${API.SENSOR_AUTHORIZATIONS_PATH}/${sensorId}/validate`);
};
